import React, {useContext} from 'react';

import {FieldDescription, Types} from '@pb/kit-component-field-description';
import {Group} from '@pb/kit-component-group';

import {ValidationContext} from './validation-context';

import type {ValidationContextType, ValidationError} from './validation-context';

type Props = {
    children: (invalid: boolean) => React.ReactNode,
    name: string,
    validate?: (value: string) => ValidationError | null,
};

export const ValidatedControl: React.FC<Props> = ({name, children, validate}) => {
    const {getErrorsByControlId} = useContext<ValidationContextType>(ValidationContext);

    let error: ValidationError | null = getErrorsByControlId(name).length ? getErrorsByControlId(name)[0] : null;

    if (validate) {
        const customError = validate(name);
        if (customError) {
            error = customError;
        }
    }

    return (
        <Group direction="v" gap="none" alignItems="start">
            {children(!!error)}
            {error ? (
                <FieldDescription color={Types.ERROR}>
                    {error.message}
                </FieldDescription>
            ) : null}
        </Group>
    );
};
